export default __webpack_public_path__ + "media/images/manual/joanr/16-d90d395f212afc2fb29553f4c79486ed.png";